// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3gLJx","btn":"Card_btn__3mnUS"};